import React from "react"
// import type { IconButtonProps } from "@chakra-ui/react"
import { AspectRatio, Box, Carousel, IconButton, Image } from "@chakra-ui/react"
import { forwardRef } from "react"
import { LuArrowLeft, LuArrowRight, LuChevronLeft, LuChevronRight } from "react-icons/lu"

export const YoutubeCarousel = () => {
  const items = [
    "https://youtu.be/dQw4w9WgXcQ?si=kxOK4qYth2S-CfRg",
    "https://youtu.be/dQw4w9WgXcQ?si=kxOK4qYth2S-CfRg",
    "https://youtu.be/dQw4w9WgXcQ?si=kxOK4qYth2S-CfRg",
  ]
  return (
    <Carousel.Root slideCount={items.length} maxW="80%" mx="auto">
      <Carousel.ItemGroup>
        {items.map((_, index) => (
          <Carousel.Item key={index} index={index}>
           <Box
  position="relative"
  w="100%"
  aspectRatio="16 / 9"
  rounded="lg"
  overflow="hidden"
>
  <iframe
    src="https://www.youtube.com/embed/VIDEO_ID"
    title="Video istruzioni"
    style={{
      width: "100%",
      height: "100%",
      border: "0",
    }}
    allowFullScreen
  />
</Box>

          </Carousel.Item>
        ))}
      </Carousel.ItemGroup>

      <Carousel.Control justifyContent="center" gap="4">
        <Carousel.PrevTrigger asChild>
          <IconButton size="xs" variant="ghost">
            <LuChevronLeft />
          </IconButton>
        </Carousel.PrevTrigger>

        <Carousel.Indicators />

        <Carousel.NextTrigger asChild>
          <IconButton size="xs" variant="ghost">
            <LuChevronRight />
          </IconButton>
        </Carousel.NextTrigger>
      </Carousel.Control>
    </Carousel.Root>
  )
}

